import * as React from "react";
import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";

import BookIcon from "@mui/icons-material/Book";
import { SearchListItemLink } from "./SearchListItemLink";
import { formatDateTime } from "src/common/UtilFunctions";

export const PageListItem = (props: any) => {
  const { data, onClick } = props;
  const { content } = data;

  if (!content) {
    return null;
  }

  return (
    <ListItem
      component={SearchListItemLink}
      data={data}
      onClick={onClick}
      alignItems="flex-start"
      sx={{
        textDecoration: "none",
        "&:hover": {
          textDecoration: "none",
        },
        "& a": {
          textDecoration: "none",
        },
        "& a:hover": {
          textDecoration: "none",
        },
      }}
      data-testid="page"
    >
      <ListItemAvatar
        sx={{
          marginX: 1,
        }}
      >
        <Avatar
          src={`${process.env.REACT_APP_AWS_CLOUDFRONT_URL}${content.image}`}
        >
          <BookIcon />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={
          <Typography
            color="textPrimary"
            sx={{
              textTransform: "capitalize",
            }}
          >
            {content.title}
          </Typography>
        }
        secondary={
          <Typography color="textSecondary">
            {formatDateTime(content.created_at)}
          </Typography>
        }
      />
    </ListItem>
  );
};
